import React from 'react';
import { 
  getCheatingProbabilityTextColorClass, 
  getCheatingProbabilityLabel,
  getCheatingProbabilityBgColorClass
} from '../../Utils/ColorUtils';

/**
 * CheatingProbabilityIndicator Component
 * Displays a badge with cheating probability and a detailed tooltip on hover
 * 
 * @param {number} probability - The cheating probability as a percentage (0-100)
 * @param {Array} rationale - Array of rationale strings explaining the probability
 * @param {Function} onClick - Optional click handler to open detailed modal
 */
const CheatingProbabilityIndicator = ({ 
  probability,
  rationale = [],
  onClick = null
}) => {
  if (probability === null || probability === undefined) return null;
  
  const probabilityValue = probability;
  
  return (
    <div 
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm relative group ${onClick ? 'cursor-pointer' : 'cursor-help'} ${getCheatingProbabilityBgColorClass(probabilityValue)}`}
      onClick={onClick}
    >
      <div className="flex items-center">
        <h3 className="text-sm font-medium">Integrity Risk:</h3>
        <span className={`ml-2 font-bold ${getCheatingProbabilityTextColorClass(probabilityValue)}`}>
          {getCheatingProbabilityLabel(probabilityValue)}
        </span>
        {onClick && (
          <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        )}
      </div>
      
      {/* Tooltip */}
      <div className="absolute z-10 hidden group-hover:block w-[400px] p-4 bg-white border border-gray-200 rounded-lg shadow-xl right-0 top-6" style={{opacity: 1, backgroundColor: 'white'}}>
        <div className="text-base text-left opacity-100">
          
          <div className="bg-gray-100 p-3 rounded-md mb-3">
            <p className="font-bold text-lg">
              Integrity Risk Score: <span className="text-xl">{probabilityValue}%</span>
            </p>
          </div>
          {rationale && rationale.length > 0 ? (
            <ul className="list-disc pl-5 space-y-1">
              {rationale.map((reason, index) => (
                <li key={index} className="text-gray-700 text-sm">{reason}</li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 italic text-sm">No rationale provided.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheatingProbabilityIndicator;
